<!-- eslint-disable max-len -->
<template>
  <svg fill="none" height="14" viewBox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      class="v-icon-fill-color"
      d="M1.5 0.5C1.5 0.223858 1.27614 0 1 0C0.723858 0 0.5 0.223858 0.5 0.5H1.5ZM15.3536 9.85355C15.5488 9.65829 15.5488 9.34171 15.3536 9.14645L12.1716 5.96447C11.9763 5.7692 11.6597 5.7692 11.4645 5.96447C11.2692 6.15973 11.2692 6.47631 11.4645 6.67157L14.2929 9.5L11.4645 12.3284C11.2692 12.5237 11.2692 12.8403 11.4645 13.0355C11.6597 13.2308 11.9763 13.2308 12.1716 13.0355L15.3536 9.85355ZM0.5 0.5V3.5H1.5V0.5H0.5ZM7 10H15V9H7V10ZM0.5 3.5C0.5 7.08985 3.41015 10 7 10V9C3.96243 9 1.5 6.53757 1.5 3.5H0.5Z"
      stroke-width="0"
    />
  </svg>
</template>
